export default __webpack_public_path__ + "static/media/groomsmart-logo.404ff7e8.png";